
import { XhrClient } from "../packages/http";
import {
  POST,
  GET,
  PUT,
  HEAD,
  CONTENT_TYPE_TEXT_HTML,
  CONTENT_TYPE_TEXT_PLAIN,
  CONTENT_TYPE_TEXT_JSON,
  CONTENT_TYPE_APP_JSON,
  CONTENT_TYPE_TEXT_VTT,
  CONTENT_TYPE_TEXT_XML,
  CONTENT_TYPE_APP_XML,
  CONTENT_ESTATUS_200,
  CONTENT_TYPE_APPLICATION_OCTET_STREAM
} from "./RequestManagerConstants";
import Utils from "../utils/Utils";
import AAFPlayer from "src/AAFPlayer/AAFPlayer";
import { refreshToken } from "./loader";
import {doLogout} from 'src/components/Modal/ModalProfile.jsx'
import logger from "src/utils/logger/logger"
import { logSessionLifecycleNewRelic } from "src/utils/newRelic_loadApp/newRelic-load-app"

let counter = 0;

const addCounter = async (request) => {
  let isSetRefresToken = false
  let refreshTokenError;
  do{
     try {
      await refreshToken();
      isSetRefresToken = true
    } catch(err) {
      refreshTokenError = err;
      logger.debug('refreshToken', err)
    }
    finally{
      counter++
    }
  }while(counter < 3 && !isSetRefresToken)

  if(isSetRefresToken){
    cleanCounter()
     const result =  await RequestManager.addRequest(request);
     return result
  }else {
    const previousUserToken = DeviceStorage.getItem('user_token') || '';
    logSessionLifecycleNewRelic({
      eventName: 'refresh_token_error',
      flowStep: 'refreshToken',
      attempt: counter - 1
    }, refreshTokenError && refreshTokenError.completeError
      ? refreshTokenError.completeError
      : refreshTokenError, 
    previousUserToken);
    doLogout(true)
  }
}

const cleanCounter = function() {
  counter = 0;
}
class RequestManager {
  static showModalRetryRequest(request) {
    return new Promise((resolve, reject) => {
      const handleRetry = async () => {
        request.getRetriesNumber = () => 0;
        resolve(this.addRequest(request));
      };
      const handleReject = () => {
        reject("Can not get request");
      };
      if(request.getUrl().indexOf('/player')!==-1){
        //si falla apis de reproduccion se reinicia las tryingToPlayOptions
        AAFPlayer.setTryingToPlayOptions(null);
      }
      request.showModalRetry(handleRetry, handleReject);
    });
  }

  static async getResponse(result, options){
    let response = null, contentType;
    if (
      result &&
      result.headers &&
      result.headers.get('content-type') !== ''
    ) {
      contentType = result.headers.get('content-type').toLowerCase();
      if (
        contentType.indexOf(CONTENT_TYPE_TEXT_HTML) !== -1 ||
        contentType.indexOf(CONTENT_TYPE_TEXT_PLAIN) !== -1 ||
        contentType.indexOf(CONTENT_TYPE_TEXT_VTT) !== -1 ||
        contentType.indexOf(CONTENT_TYPE_TEXT_XML) !== -1 ||
        contentType.indexOf(CONTENT_TYPE_APP_XML) !== -1
      ) {
        response = await result.body.asText();
      }
      else if(contentType.indexOf(CONTENT_TYPE_APPLICATION_OCTET_STREAM) !== -1){
        response= await result.body.asArrayBuffer();
      }
      else if (
        contentType.indexOf(CONTENT_TYPE_TEXT_JSON) !== -1 ||
        contentType.indexOf(CONTENT_TYPE_APP_JSON) !== -1
      ) {
        response = await result.body.asJSON();
      } else {
        response = await result.body.asJSON();
      }
    }else{
      if(options && options.isVtt){
        response = await result.body.asText();
      }
    }
    return response;
  }

  /**
   * [addRequest send request]
   * @type AbstractRequestTask request
   * @return Promise
   */
  static async addRequest(request) {
    if (!request) {
      throw new Error("request object is required");
    }
    const xhrClient = new XhrClient();
    let rurl = request.getUrl();

    if(rurl.substring(0, 4) !== 'http') {
      rurl = (window.location && window.location.protocol) ? window.location.protocol + '//' + rurl : 'http://' + rurl ;
    }

    const options = {
      method: request.getMethod() || GET,
      url: request.replaceProtocol(rurl),
      retries: request.getRetriesNumber(),
      headers: request.getHeaders(),
      statusCode400As200: request.getStatusCode400As200(),
      statusCode401As200: request.getStatusCode401As200(),
      statusCode402As200: request.getStatusCode402As200(),
      statusCode403As200: request.getStatusCode403As200(),
      statusCode409As200: request.getStatusCode409As200(),
      statusCode422As200: request.getStatusCode422As200(),
      statusCode304As200: request.getStatusCode304As200(),
      statusCode429As200: request.getStatusCode429As200(),
      statusCode404As200: request.getStatusCode404As200(),
      statusCode500As200: request.getStatusCode500As200(),
      statusCode501As200: request.getStatusCode501As200(),
      overwriteHttps: request.getIsByHttps(),
      responseType: request.getResponseType(),
      isVtt: request && (typeof  request.getIsVTT === 'function') && request.getIsVTT() || false
    };

    const paramsUpdate = request.getParams();
    const isUrlWithVersion = (rurl.includes("/v1/") || rurl.includes("/v2/") || rurl.includes("/v3/"));
    const isBlackList = (
                          rurl.includes("services/user/v1/isloggedin") ||
                          rurl.includes("services/user/v1/authdevice")
                        );

    if(isBlackList || !isUrlWithVersion) delete paramsUpdate.user_token;

    switch (options.method) {
      case POST:
      case PUT:
        switch (request.getEncType()) {
          case "multipart/form-data":
            const params = paramsUpdate;
            const formDataParams = new FormData();
            for (const key in params) {
              formDataParams.append(key, params[key]);
            }
            options.body = formDataParams;
            break;
          case "application/json":
            options.body = JSON.stringify(paramsUpdate);
            break;
          default:
            options.body = Utils.buildQueryParams(paramsUpdate);
        }
        break;
      case 'DELETE':
        if (request.getEncType() === 'application/json') {
          options.body = JSON.stringify(paramsUpdate);
        } else {
          options.body = Utils.buildQueryParams(paramsUpdate);
        }
        break;
      case HEAD:
        delete options.query;
        break;
      case GET:
      default:
        options.query = paramsUpdate;
    }

    const startTime = Date.now();

    return xhrClient
      .request(options)
      .then(async (result) => {
        const status = result.status;
        const durationMs = Date.now() - startTime;
        const httpStatus = result.httpStatus !== undefined && result.httpStatus !== 0 ? result.httpStatus : result.status;
        const headers = result.headers;
        const responseContentType = headers ? headers.get('content-type') || '' : '';
        let response;
        try {
          response = await this.getResponse(result, options);
        } catch (parseError) {
          parseError.httpStatus = httpStatus;
          parseError.durationMs = durationMs;
          parseError.endpoint = options.url;
          parseError.headers = headers;
          parseError.responseContentType = responseContentType;
          parseError.malformedJson = responseContentType.toLowerCase().includes('application/json') || responseContentType.toLowerCase().includes('text/json');
          parseError.emptyResponse = headers && headers.get('content-length') === '0';
          throw parseError;
        }
        if (request.isValid(response)) {
          if (response && typeof response === 'object') {
            response.httpStatus = httpStatus;
            response.endpoint = options.url;
            response.durationMs = durationMs;
            response.headers = headers;
            response.responseContentType = responseContentType || 'unknown';
            if (response.errors) {
              const rawBody = JSON.stringify(response);
              response.rawBody = rawBody;
            }
          }
          if (response.data) {
            // Flujo para las apis versionadas que ya viene solo con data,
            // esto es para adecuar a la estrUctura actual soportada con response
            response.response = response.data;
            response.status = status;
            response.httpStatus = httpStatus;
            response.endpoint = options.url;
            response.durationMs = durationMs;
            response.headers = headers;
            response.responseContentType = responseContentType || 'unknown';
          }
          return response;
        } else {
          let error = new Error();
          error = {response,status,httpStatus,headers,responseContentType,durationMs,endpoint: options.url};
          throw error
        }
      })
      .catch(async (error) => {
        const durationMs = Date.now() - startTime;
        const headers = error && (error.headers || (error.response && error.response.headers));
        let responseContentType = '';
        if (error && error.responseContentType) {
          responseContentType = error.responseContentType;
        } else if (headers && typeof headers.get === 'function') {
          responseContentType = headers.get('content-type');
        }
        const responseBody = error && error.data && typeof error.data.asText === 'function'
          ? error.data
          : error && error.body && typeof error.body.asText === 'function'
            ? error.body
            : error && error.response && error.response.data && typeof error.response.data.asText === 'function'
              ? error.response.data
              : null;
        let rawBody = '';
        if (error && error.rawBody) rawBody = error.rawBody;
        let malformedJson = Boolean(error && error.malformedJson);
        let emptyResponse = Boolean(error && error.emptyResponse);
        let errorData;
        if (responseBody) {
          try {
            rawBody = await responseBody.asText();
            emptyResponse = rawBody.length === 0;
            if (responseContentType.toLowerCase().includes('application/json')) {
              try {
                errorData = JSON.parse(rawBody);
              } catch (parseError) {
                malformedJson = true;
                errorData = { message: parseError.message };
              }
            } else {
              errorData = { body: rawBody };
            }
          } catch (bodyError) {
            errorData = error;
          }
        }
        const responseMetadata = {
          status: error && (error.httpStatus !== undefined ? error.httpStatus : error.status),
          httpStatus: error && (error.httpStatus !== undefined ? error.httpStatus : error.status),
          headers,
          responseContentType,
          malformedJson,
          emptyResponse,
          abortReason: error && error.abortReason,
          endpoint: options.url,
          durationMs,
          rawBody,
        };
        if (request.getShowErrorModal() && error.status && error.status!== CONTENT_ESTATUS_200) {
          return this.showModalRetryRequest(request);
        } else {
          if (!errorData && error.response && error.response.data && (typeof error.response.data.asJSON === 'function')) {
            errorData = await error.response.data.asJSON();
          }
          if (!errorData) {
            errorData = error && error.response ? error.response : error;
          }
          if (errorData && errorData.entry) {
            errorData.entry.url = options.url;
          }

          const errors = errorData && (errorData.errors ||
            (errorData.response && errorData.response.errors));
          if (errors) {
            const error401 = Array.isArray(errors)
              ? errors[0] && errors[0].code
              : errors[0] ? errors[0].code : errors.code;
            const { url } = options;
            /**
             * urls are not allowed to refresh token STV-18139
             */
            const urlLoginByToken = url.includes("loginbytoken");
            const urlRefreshToken = url.includes("refresh_token");
            const urlOttIsLoggedIn = url.includes("ott/isloggedin");
            const urlOttLogin = url.includes("ott/login");
            if (error401 === 'USR_JWT_00002' || error401 === 'USR_JWT_00001') {
              if(!(urlLoginByToken || urlRefreshToken || urlOttIsLoggedIn || urlOttLogin)) {
                return await addCounter(request, error);
              }
            }
          }
          const errorBody = errorData && typeof errorData === 'object'
            ? errorData
            : { body: errorData };
          const errorDataWithMetadata = {
            ...errorBody,
            ...responseMetadata,
            rawBody: rawBody !== '' || responseMetadata.emptyResponse
              ? rawBody
              : typeof errorData === 'string' ? errorData : JSON.stringify(errorData),
          };
          throw request.parseErrors(errorDataWithMetadata) || error;
        }
      });
  }
}

export default RequestManager;



// WEBPACK FOOTER //
// ./src/requests/RequestManager.js